import {
  AdminPolicy,
  PostFlightPolicy,
  PreFlightPolicy,
  ProfilePolicy,
  BetaPolicy
} from './policy-types.model';
import { PermissionValidator } from './permission.model';

export const permissionTypes = {
  profile: {
    aircraft: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.AircraftProfileReadOnly, ProfilePolicy.AircraftProfileFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.AircraftProfileFullAccess], true)
    },
    airport: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.AirportProfileReadOnly, ProfilePolicy.AirportProfileFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.AirportProfileFullAccess], true)
    },
    checklist: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.ChecklistProfileReadOnly, ProfilePolicy.ChecklistProfileFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.ChecklistProfileFullAccess], true)
    },
    company: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.CompanyProfileReadOnly, ProfilePolicy.CompanyProfileFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.CompanyProfileFullAccess], true)
    },
    people: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.PersonProfileReadOnly, ProfilePolicy.PersonProfileFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.PersonProfileFullAccess], true)
    },
    trainingRequirement: {
      readAccess: new PermissionValidator(
        [
          ProfilePolicy.CurrencyTrainingEventsReadOnly,
          ProfilePolicy.CurrencyTrainingEventsFullAccess
        ],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.CurrencyTrainingEventsFullAccess], true)
    },
    rolesManagement: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.UserManagementReadOnly, ProfilePolicy.UserManagementFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true),
      rolesMatrix: {
        canViewRoles: new PermissionValidator(
          [ProfilePolicy.UserManagementReadOnly, ProfilePolicy.UserManagementFullAccess],
          false
        ),
        canCreateRoles: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true),
        canEditRoles: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true),
        canRemoveRoles: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true)
      },
      usersList: {
        canViewUsers: new PermissionValidator(
          [ProfilePolicy.UserManagementReadOnly, ProfilePolicy.UserManagementFullAccess],
          false
        ),
        canUpdateRoles: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true)
      }
    },
    userManagement: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.UserManagementReadOnly, ProfilePolicy.UserManagementFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.UserManagementFullAccess], true)
    },
    organizationalView: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.OrganizationViewReadOnly, ProfilePolicy.OrganizationViewFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.OrganizationViewFullAccess], true)
    },
    airportNotes: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.AirportNotesReadOnly, ProfilePolicy.AirportNotesFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.AirportNotesFullAccess], true)
    },
    integrationManagement: {
      readAccess: new PermissionValidator(
        [
          ProfilePolicy.IntegrationManagementReadOnly,
          ProfilePolicy.IntegrationManagementFullAccess
        ],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.IntegrationManagementFullAccess], true)
    },
    eSignature: {
      readAccess: new PermissionValidator(
        [ProfilePolicy.ESignatureReadOnly, ProfilePolicy.ESignatureFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([ProfilePolicy.ESignatureFullAccess], true)
    }
  },
  preflight: {
    linkAccess: new PermissionValidator(
      [
        PreFlightPolicy.DayCalendarReadOnly,
        PreFlightPolicy.WeeklyCalendarReadOnly,
        PreFlightPolicy.MonthlyCalendarReadOnly,
        PreFlightPolicy.StaffEventScheduleReadOnly,
        PreFlightPolicy.DayCalendarFullAccess,
        PreFlightPolicy.WeeklyCalendarFullAccess,
        PreFlightPolicy.MonthlyCalendarFullAccess,
        PreFlightPolicy.StaffEventScheduleFullAccess
      ],
      false
    ),
    dayCalendar: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.DayCalendarReadOnly, PreFlightPolicy.DayCalendarFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.DayCalendarFullAccess], true)
    },
    CalendarNotes: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.CalendarNotesReadOnly, PreFlightPolicy.CalendarNotesFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.CalendarNotesFullAccess], true)
    },
    weeklyCalendar: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.WeeklyCalendarReadOnly, PreFlightPolicy.WeeklyCalendarFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.WeeklyCalendarFullAccess], true)
    },
    monthlyCalendar: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.MonthlyCalendarReadOnly, PreFlightPolicy.MonthlyCalendarFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.MonthlyCalendarFullAccess], true)
    },
    staffCalendar: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.StaffEventScheduleReadOnly, PreFlightPolicy.StaffEventScheduleFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.StaffEventScheduleFullAccess], true)
    },
    aircraftEvent: {
      readAccess: new PermissionValidator(
        [
          PreFlightPolicy.AircraftEventScheduleReadOnly,
          PreFlightPolicy.AircraftEventScheduleFullAccess
        ],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.AircraftEventScheduleFullAccess], true)
    },
    buildTrip: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.TripBuilderReadOnly, PreFlightPolicy.TripBuilderFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.TripBuilderFullAccess], true)
    },
    unlocktrip: {
      writeAccess: new PermissionValidator([PreFlightPolicy.UnlockTrip], true)
    },
    canSendMobileNotificaitons: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.AcknowledgementReadOnly, PreFlightPolicy.AcknowledgementFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.AcknowledgementFullAccess], true)
    },
    fuelVendorUpload: {
      readAccess: new PermissionValidator(
        [PreFlightPolicy.FuelVendorUploadReadonly, PreFlightPolicy.FuelVendorUploadFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PreFlightPolicy.FuelVendorUploadFullAccess], true)
    },
    acknowledgements: {
      writeAccess: new PermissionValidator([PreFlightPolicy.AcknowledgementFullAccess], true)
    }
  },
  postFlight: {
    adjustments: {
      readAccess: new PermissionValidator([
        PostFlightPolicy.TimeCycleAdjustmentsReadOnly,
        PostFlightPolicy.TimeCycleAdjustmentsFullAccess
      ]),
      writeAccess: new PermissionValidator([PostFlightPolicy.TimeCycleAdjustmentsFullAccess], true)
    },
    campActions: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.CampActionsReadOnly, PostFlightPolicy.CampActionsFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.CampActionsFullAccess], true)
    },
    expenses: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.ExpenseCaptureReadOnly, PostFlightPolicy.ExpenseCaptureFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.ExpenseCaptureFullAccess], true)
    },
    fleetOverview: {
      //Per ECS-2688, temporarily allow read only users access to open chart dialogs.  Mechanic and DOM roles
      //do not have FleetTripLegFullAccess, but do need to be able to edit the charts.  The correct solution would be
      //to create a new set of permissions just for FleetOverview (FleetTripLegFullAccess allows editing non-Fleet overview
      //behavior which we don't necessarily want to give to Mechanics and DOM); the short term solution agreed upon by PMs
      //is to just lower the permission of editing charts until then.
      canOpenVorFmsJeppDialogs: new PermissionValidator(
        [PostFlightPolicy.FleetTripLegReadOnly, PostFlightPolicy.FleetTripLegFullAccess],
        false
      )
    },
    flightLog: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.FlightLogReadOnly, PostFlightPolicy.FlightLogFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.FlightLogFullAccess], true)
    },
    pilotLogbook: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.PilotLogbookReadOnly, PostFlightPolicy.PilotLogbookFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.PilotLogbookFullAccess], true)
    },
    reports: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.ReportsReadOnly, PostFlightPolicy.ReportsFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.ReportsFullAccess], true)
    },
    sifl: {
      readAccess: new PermissionValidator([
        PostFlightPolicy.SiflReadOnly,
        PostFlightPolicy.SiflFullAccess
      ]),
      writeAccess: new PermissionValidator([PostFlightPolicy.SiflFullAccess], true)
    },
    tripManager: {
      readAccess: new PermissionValidator(
        [PostFlightPolicy.FleetTripLegReadOnly, PostFlightPolicy.FleetTripLegFullAccess],
        false
      ),
      writeAccess: new PermissionValidator([PostFlightPolicy.FleetTripLegFullAccess], true),
      canVerifyLeg: new PermissionValidator([PostFlightPolicy.LegVerificationsFullAccess], true),
      canUnverifyLeg: new PermissionValidator(
        [PostFlightPolicy.LegUnVerificationsFullAccess],
        true
      ),
      canVerifyTrip: new PermissionValidator([PostFlightPolicy.TripVerificationsFullAccess], true),
      canUnverifyTrip: new PermissionValidator(
        [PostFlightPolicy.TripUnVerificationsFullAccess],
        true
      )
    },
    dashboard: {
      writeAccess: new PermissionValidator([PostFlightPolicy.Dashboard], true)
    }
  },
  beta: {
    canViewReports: new PermissionValidator([BetaPolicy.ReportsReadOnly])
  },
  admin: {
    HistoricalUpload: {
      readAccess: new PermissionValidator(
        [AdminPolicy.HistoricalUploadReadOnly, AdminPolicy.HistoricalUploadReadOnly],
        false
      ),
      writeAccess: new PermissionValidator([AdminPolicy.HistoricalUploadReadOnly], true)
    },
    FlightPlanSimulator: {
      readAccess: new PermissionValidator(
        [AdminPolicy.HistoricalUploadReadOnly, AdminPolicy.HistoricalUploadReadOnly],
        false
      ),
      writeAccess: new PermissionValidator([AdminPolicy.HistoricalUploadReadOnly], true)
    }
  }
};
